import { createAsyncThunk } from "@reduxjs/toolkit";
import { addonConfirmCTRPurchaseApi, addonCTRPurchaseApi, addonEditCTRFormApi, addonGetCTRFormApi, addonMapCheckInsPurchaseApi } from "../../apis";
import { IAddonEditCTRFormData } from "../../apis/IApisInterface";

export const addonCTRPurchaseAction = createAsyncThunk("addon/ctr/purchase", async (business_id: string, { rejectWithValue }) => {
    try {
        const response = await addonCTRPurchaseApi(business_id);
        return response.data
    } catch (error: any) {
        return rejectWithValue(error || { message: "Could not purchase ctr"})
    }
})

export const addonMapCheckInsPurchaseAction = createAsyncThunk("addon/map-checkins/purchase", async (business_id: string, { rejectWithValue }) => {
    try {
        const response = await addonMapCheckInsPurchaseApi(business_id);
        return response.data
    } catch (error: any) {
        return rejectWithValue(error || { message: "Could not purchase map checkins"})
    }
})

export const addonConfirmCTRPurchaseAction = createAsyncThunk("addon/confirm/ctr/purchase", async (id: string, { rejectWithValue }) => {
    try {
        const response = await addonConfirmCTRPurchaseApi(id);
        return response.data
    } catch (error: any) {
        return rejectWithValue(error || { message: "Could not confirm purchase ctr"})
    }
})

export const addonGetCTRFormAction = createAsyncThunk("addon/get/ctr-form", async (business_id: string, { rejectWithValue }) => {
    try {
        const response = await addonGetCTRFormApi(business_id);
        return response.data
    } catch (error: any) {
        return rejectWithValue(error || { message: "Could not get addon ctr form"})
    }
})

export const addonEditCTRFormAction = createAsyncThunk("addon/edit/ctr-form", async (data: IAddonEditCTRFormData, { rejectWithValue }) => {
    try {
        const response = await addonEditCTRFormApi(data);
        return response.data
    } catch (error: any) {
        return rejectWithValue(error || { message: "Could not edit addon ctr form"})
    }
})